import React from 'react'
import { Spinner } from 'reactstrap'
import '../views/stylesheets/loader.scss'
export default function PageLoader () {
  return (
    <div className='loader-overlay'>
      <div className='loader-div'>
        <Spinner type='grow' color='secondary' />
      </div>
    </div>
  )
}
